<template>
    <div>
        <!-- ------------------------------------------- -->
        <!--  CONTENIDO DE CONSTRUCCION A PARTIR DE AQUI -->
        <!-- ------------------------------------------- -->
        <pagina-construccion
            nombreApartado="Transparencia"
            enlace="http://www.haciendachiapas.gob.mx/">
        </pagina-construccion>
    </div>
</template>
<script>
import paginaConstruccion from './../Construccion'
export default {
    mounted(){
        window.scrollTo(0, 0);
    },
    components:{
        paginaConstruccion,
    },
}
</script>
